import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SetNearbyPrivacyPreferenceRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { SetNearbyPrivacyPreferenceResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const setNearbyPrivacyPreference = (request: SetNearbyPrivacyPreferenceRequest, options?: CashRequestOptions) =>
  post<SetNearbyPrivacyPreferenceRequest, SetNearbyPrivacyPreferenceResponse>(
    '/2.0/cash/set-nearby-privacy-preference',
    request,
    { ...options, rejectOnError: true }
  )
